export default {"src":"/_next/static/media/youtube.728136c0.svg","height":42,"width":42,"blurWidth":0,"blurHeight":0};